import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import BlockUserNotifPageUI from './BlockUserNotifPageUI.js'

class BlockUserNotifPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      submitted: false,
    }
  }

  render() {
    return (
      <BlockUserNotifPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        onCancel={this.onCancel}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = (event) => {
    if (this.state.submitted)
      return

    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      `/api/pub/users/${this.props.match.params.encryptedUserId}/emailAcceptance`,
      this.onSubmitCallback, {
        emailAcceptance: 'block',
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({submitted: false, errorList: errorList, successMsg: response.success})

    if (errorList.length === 0) {
      setTimeout(() => {
        window.location = '/'
      }, 3000);
    }
  }

  onCancel = (event) => {
    window.location = '/'
  }

  getMessages(context) {
    let arr = [
      'c_opt_out_email_q',
      'c_opt_out_email_desc',
      'c_email_opt_in_hint',
      'c_opt_out',
      'c_cancel',
      'c_continue',
      'c_not_found'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_blk_usr_eml', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
    // cannot check session because user id was encrypted in URL
    // this.checkSession()
  }

  /*
  // if user id not matching, logout the user
  checkSession() {
    let context = this.props.context
    let userIdsession = context.session.userId
    let userIdParam = this.props.match.params.userId
    if (userIdsession && userIdsession !== userIdParam) {
      sessions.delete(context, this.deleteSessionCallback)
    }
  }

  deleteSessionCallback = (response) => {
    let context = this.props.context
    localStorage.removeItem(LocalStorageKeys.Session)
    localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
    let sessionHelper = new SessionHelper(context)
    sessionHelper.getSession()
  }
  */

}

export default withRouter(BlockUserNotifPageSF)
